import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";

function Register() {
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");  
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("apprenti");

  const navigate = useNavigate();

  // 🔒 PROTECTION ADMIN
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || user.role !== "admin") {
      navigate("/members");
    }
  }, [navigate]);

  // 🔥 CREATE USER
  const handleRegister = async () => {
    try {
      await API.post("/users", {
        firstname,
        lastname,
        email,
        password,
        phone,
        role,
      });

      alert("✅ Utilisateur créé !");
      navigate("/members"); // 🔥 retour auto

    } catch (err) {
      console.log(err);
      alert(err.response?.data?.message || "Erreur");
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>➕ Créer un membre</h2>

      <input
        placeholder="Prénom"
        value={firstname}
        onChange={(e) => setFirstname(e.target.value)}
        style={styles.input}
      />

      <input
        placeholder="Nom"
        value={lastname}
        onChange={(e) => setLastname(e.target.value)}
        style={styles.input}
      />

      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={styles.input}
      />

      <input
        type="password"
        placeholder="Mot de passe"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        style={styles.input}
      />

      <input
        placeholder="Téléphone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
        style={styles.input}
      />

      <select
        value={role}
        onChange={(e) => setRole(e.target.value)}
        style={styles.input}
      >
        <option value="apprenti">Apprenti</option>
        <option value="compagnon">Compagnon</option>
        <option value="maitre">Maître</option>
        <option value="admin">Admin</option>
      </select>

      <button onClick={handleRegister} style={styles.button}>
        Créer
      </button>

      <button onClick={() => navigate(-1)} style={styles.cancel}>
        Annuler
      </button>
    </div>
  );
}

export default Register;

// ===============================
// 🎨 STYLES
// ===============================
const styles = {
  container: {
    padding: 20,
    background: "#0f172a",
    height: "100vh",
    color: "white",
  },

  title: {
    fontSize: 22,
    fontWeight: "700",
    marginBottom: 20,
  },

  input: {
    display: "block",
    width: "100%",
    padding: 12,
    marginTop: 10,
    borderRadius: 10,
    border: "none",
    background: "#1e293b",
    color: "white",
  },

  button: {
    marginTop: 20,
    padding: 12,
    width: "100%",
    borderRadius: 10,
    border: "none",
    background: "#22c55e",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
  },

  cancel: {
    marginTop: 10,
    padding: 10,
    width: "100%",
    border: "none",
    background: "transparent",
    color: "#94a3b8",
  },
};